export enum PullRequestStatus {
  MERGED = 'MERGED',
  CLOSED = 'CLOSED',
  CHECKS_FAILING = 'CHECKS_FAILING',
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  COMMENTS_TO_ADDRESS = 'COMMENTS_TO_ADDRESS',
  CHECKS_RUNNING = 'CHECKS_RUNNING',
  APPROVED = 'APPROVED',
  CHECKS_PASSED = 'CHECKS_PASSED',
  READY = 'READY',
}

export enum PullRequestSignalKind {
  CHECKS_RUNNING = 'CHECKS_RUNNING',
  CHECKS_FAILING = 'CHECKS_FAILING',
  CHECKS_PASSED = 'CHECKS_PASSED',
  APPROVED = 'APPROVED',
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  REVIEW_REQUIRED = 'REVIEW_REQUIRED',
  COMMENTS = 'COMMENTS',
}
